var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-frame view"},[_c('header-com',{attrs:{"tit":_vm.titText}}),_c('el-container',{staticClass:"home-box"},[_c('el-main',[_c('router-view',{key:_vm.$route.name}),_c('log')],1)],1),_c('zx-footer',{staticStyle:{"position":"absolute","bottom":"0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }